<div class="container-padding">
  <ng-container *ngIf="isValid == false">
    <div class="centered fail-mobile">
      <img
        style="width: 15rem"
        src="assets/images/tickets/failure.svg"
        alt=""
      />
      <div>
        <h2 class="title">{{ "BookingFailed" | translate }}</h2>
      </div>
      <button
        type="button"
        class="btn"
        style="
          background-color: white;
          padding: 16px !important;
          border-radius: 10px !important;
          font-size: 16px;
          font-weight: 530 !important;
          color: #0b2027;
          border-color: #0b2027;
        "
        [routerLink]="'/'"
      >
        {{ "TryAgain" | translate }}
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="isValid">
    <div class="centered">
      <img
        style="width: 15rem"
        src="assets/images/tickets/success.svg"
        alt=""
      />
      <div>
        <h2 class="title">{{ "BookingSuccess" | translate }}</h2>
        <button
          type="button"
          class="btn"
          style="
            background-color: #0b2027;
            padding: 16px !important;
            border-radius: 10px !important;
            color: white;
            font-size: 20px !important;
            font-weight: 530 !important;
            display: flex;
            place-items: center;
          "
          (click)="downloadInvoice()"
        >
          <img src="assets/images/tickets/download.svg" class="px-2" />
          <span>{{ "DownloadAllTickets" | translate }}</span>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="tickets && tickets.orders?.length && isValid">
    <div class="tickets-container">
      <div class="d-flex justify-content-between px-4 mobile">
        <div class="info-block">
          <div class="row">
            <p class="info-title">{{ "Event details" | translate }}</p>
          </div>
          <div class="row">
            <p class="info-value">
              {{ helpers.getElementTranslatedName(tickets.event) }}
            </p>
          </div>
          <div class="row">
            <p
              style="unicode-bidi: plaintext; color: #555770"
              class="info-title"
            >
              {{
                "tickets-bought-quantity"
                  | translate : { value: tickets?.orders?.length }
              }}
            </p>
          </div>
        </div>
        <div class="info-block">
          <div class="row">
            <p class="info-title">{{ "your name" | translate }}</p>
          </div>
          <div class="row">
            <p class="info-value">
              {{ tickets?.metadata?.name?.first }}
              {{ tickets?.metadata?.name?.last }}
            </p>
          </div>
          <div class="row">
            <p
              style="unicode-bidi: plaintext; color: #555770"
              [ngStyle]="{
                'text-align-last':
                  translate.currentLang == 'ar' ? 'end' : ' start'
              }"
              class="info-title"
            >
              {{ tickets?.metadata?.mobile }}
            </p>
          </div>
        </div>
        <div class="info-block">
          <div class="row">
            <p class="info-title">{{ "Amount" | translate }}</p>
          </div>
          <div class="row">
            <p class="info-value">
              <ng-container *ngIf="tickets?.grandTotal !== 0">
                <span
                  [innerHTML]="
                    tickets?.grandTotal
                      | customCurrency : 'SAR' : 'symbol' : '#28293d' : 33
                  "
                ></span>
              </ng-container>
              <ng-container *ngIf="tickets?.grandTotal === 0">
                {{ "free" | translate }}
              </ng-container>
            </p>
          </div>
          <div class="row">
            <p
              *ngIf="tickets?.grandTotal !== 0"
              style="unicode-bidi: plaintext; color: #555770"
              class="info-title"
            >
              {{ "Tax Included" | translate }}
            </p>
          </div>
        </div>
      </div>
      <hr class="dashed" />
      <div style="padding: 5%; padding-top: 1%" class="pb-0">
        <app-order-item
          [order]="order"
          [event]="tickets.event"
          *ngFor="let order of tickets?.orders"
        ></app-order-item>
      </div>
    </div>
  </ng-container>
</div>

<div class="d-flex book-footer">
  <button
    routerLink="/"
    class="btn back-mobile"
    style="
      background-color: #0b2027;
      padding: 16px !important;
      border-radius: 10px !important;
      font-size: 16px;
      font-weight: 530 !important;
      color: white;
    "
  >
    <i *ngIf="translate.currentLang == 'ar'" class="fa fa-arrow-right mx-2"></i>
    <i *ngIf="translate.currentLang == 'en'" class="fa fa-arrow-left mx-2"></i>

    {{ "Go back" | translate }}
  </button>
</div>
